import thdCustomer from "@thd-olt-global/thd-customer";
import {getTMXSessionID} from "../utils";

export function getCustomerProfileRequest() {
  return {
    url:  `/customer/account/v1/${thdCustomer.svocID}/profile/v2`,
    headers: {
      "Authorization": thdCustomer.jwt
    }
  }
}

export function changePasswordRequest(newPassword, currentPassword,  oldEmail, newEmail, firstName, timeStamp) {
  return {
    url: `/customer/account/v1/${thdCustomer.svocID}/profile/changePassword`,
    data: {
      identity: {
        emailLastModifiedDate: timeStamp,
        firstName,
        logonId: oldEmail,
        newLogonId: newEmail,
        password: currentPassword,
        newPassword
      }
    },
    headers: {
      "Authorization": thdCustomer.jwt
    }
  }
}

export function getOldPhoneOTPRequest(emailId, phone, otpChannel, phoneVerified, sessionId) {
  return {
    url: `/customer/account/v1/${thdCustomer.svocID}/getOldPhoneOTP?emailId=${emailId}&oldPhoneNumber=${phone}&otpChannel=${otpChannel}&phoneVerified=${window.encodeURIComponent(phoneVerified)}`,
    headers: {
      "Authorization": thdCustomer.jwt,
      "sessionId": sessionId
    }
  }
}

export function getNewPhoneOTPRequest(emailId, phone, otpChannel, userId, sessionId, phoneVerified) {
  return {
    url: `/customer/account/v1/${thdCustomer.svocID}/getNewPhoneOTP?emailId=${emailId}&newPhoneNumber=${phone}&otpChannel=${otpChannel}${userId ? "&userId=" + window.encodeURIComponent(userId) : ""}&phoneVerified=${window.encodeURIComponent(phoneVerified)}`,
    headers: {
      "Authorization": thdCustomer.jwt,
      "sessionId": sessionId
    }
  }
}

export function updateNewEmailPreferencesRequest(emailAddress, subscriptions) {
  return {
    url: "/cdg/epc/v3/email/update",
    data: {
      emailAddress,
      subscriptions,
      sourceId: "MY_ACCOUNT_SECURITY"
    },
    headers: {
      "x-client-id": "my-account-security-page"
    }
  }
}

export function verifyOldPhoneOTPRequest(data) {
  return {
    url: `/customer/account/v1/${thdCustomer.svocID}/verifyOldPhoneOTP`,
    data,
    headers: {
      "Authorization": thdCustomer.jwt
    }
  };
}

export function verifyNewPhoneOTPRequest(data) {
  return {
    url: `/customer/account/v1/${thdCustomer.svocID}/verifyNewPhoneOTP`,
    data,
    headers: {
      "Authorization": thdCustomer.jwt
    }
  };
}

export function updateEmailWithOTPRequest(otp, authId, otpUserId, backendHostName, oldEmail, newEmail, timeStamp, autoToken) {
  return {
    url: `/customer/account/v1/${thdCustomer.svocID}/profile/updateEmail`,
    data: {
      "emailUpdateVerifyOTPRequest": {
        authId,
        otp,
        backendHost: backendHostName,
        customerId: thdCustomer.svocID,
        emailLastModifiedDate: timeStamp,
        userId: otpUserId,
        ...(autoToken && {autoToken})
      }
    },
    headers: {
      "Authorization": thdCustomer.jwt
    }
  };
}

export function askForEmailPreferencesRequest(emailAddress) {
  return {
    url: "/cdg/epc/v3/email/retrieve",
    data: {
      emailAddress
    },
    headers: {
      "x-client-id": "my-account-security-page"
    }
  };
}

export function askForEmailChangeRequest(oldEmail, newEmail, phoneVerified, otpChannel, autoToken) {
  return {
    url: `/customer/account/v1/${thdCustomer.svocID}/getEmailOTP`,
    data: {
      "emailUpdateGetOTPRequest": {
        loginId: oldEmail,
        newLogonId: newEmail,
        sessionId: getTMXSessionID(),
        phoneVerified,
        otpChannel,
        ...(autoToken && {autoToken})
      }
    },
    headers: {
      "Authorization": thdCustomer.jwt
    }
  };
}

export function updateOldEmailPreferencesRequest(emailAddress, subscriptionsParam) {
  let subscriptions = subscriptionsParam;

  subscriptions.forEach(sub => sub.optOutReason = "my_account_email_update")

  return {
    url: "/cdg/epc/v3/email/update",
    data: {
      emailAddress,
      subscriptions,
      sourceId: "MY_ACCOUNT_SECURITY"
    },
    headers: {
      "x-client-id": "my-account-security-page"
    }
  }
}

export function newUpdateEmailWithOTPRequest(otp, authId, otpUserId, backendHostName, oldEmail, newEmail, timeStamp, phoneVerified, autoToken) {
  return {
    url: `/customer/account/v1/${thdCustomer.svocID}/profile/updateEmail`,
    data: {
      "emailUpdateVerifyOTPRequest": {
        authId,
        loginId: oldEmail,
        newLogonId: newEmail,
        otp,
        backendHost: backendHostName,
        customerId: thdCustomer.svocID,
        emailLastModifiedDate: timeStamp,
        userId: otpUserId,
        phoneVerified,
        ...(autoToken && {autoToken})
      }
    },
    headers: {
      "Authorization": thdCustomer.jwt
    }
  };
}

export function getPhoneVerificationOTP(emailId, phone, otpChannel) {
  return {
    url: `/customer/account/v1/${thdCustomer.svocID}/getPhoneOTP?emailId=${emailId}&phoneNumber=${phone}&otpChannel=${otpChannel}`,
    headers: {
      "Authorization": thdCustomer.jwt
    }
  }
}

export function verifyOTPRequest(data) {
  return {
    url: `/customer/account/v1/${thdCustomer.svocID}/verifyPhoneOTP`,
    data,
    headers: {
      "Authorization": thdCustomer.jwt
    }
  };
}

export function getOTPRequest(oldEmail, newEmail, phoneVerified, otpChannel, autoToken) {
  return {
    url: `/customer/account/v1/${thdCustomer.svocID}/getEmailOTP`,
    headers: {
      "Authorization": thdCustomer.jwt
    },
    data: {
      emailUpdateGetOTPRequest: {
        loginId: oldEmail,
        newLogonId: newEmail,
        sessionId: getTMXSessionID(),
        phoneVerified,
        otpChannel,
        ...(autoToken && {autoToken})
      }
    }
  };
}

export function updateCustomerProfileRequest(account) {
  return {
    url: `/customer/account/v1/${thdCustomer.svocID}/profile/updateTwoFactorAuthOptIn`,
    data: {
      twoFactorAuthOptIn: account?.profile.twoFactorAuthOptIn
    },
    headers: {
      "Authorization": thdCustomer.jwt
    }
  }
}

export function getAllSessionsRequest() {
  return {
    url: "/customer/account/v1/session/all",
    headers: {
      "Authorization": thdCustomer.jwt
    }
  }
}

export function logoutAllSessions() {
  return {
    url: "/customer/auth/v1/logout/all",
    headers: {
      "Authorization": thdCustomer.jwt
    }
  }
}

export function logoutCurrentDevice() {
  return {
    url: "/customer/auth/v1/logout",
    headers: {
      "Authorization": thdCustomer.jwt
    }
  }
}

export function logoutDevice(sessionId, tmxProfileId) {
  return {
    url: "/customer/auth/v1/session/logout",
    data: { sessionId, tmxProfileId },
    headers: {
      "Authorization": thdCustomer.jwt
    }
  }
}

export function unenrollFromPasswordlessRequest() {
  return {
    url: "/customer/auth/v1/pwdLessUnenroll",
    data: { tmxProfileId: getTMXSessionID() },
    headers: {
      "Authorization": thdCustomer.jwt
    }
  }
}

export function getOTPv2Request(email, encryptedPayload, otpOption) {
  return {
    url: "/customer/auth/v1/otp/get",
    data: {
      email,
      encryptedPayload,
      otpOption
    },
    headers: {
      "Authorization": thdCustomer.jwt,
      "TMXProfileID": getTMXSessionID()
    }
  }
}
// yet to be fine tuned
export function passwordlessEnrollmentVerifyOTPRequest (email, encryptedPayload, otp, passwordlessOptions) {
  return {
    url: "/customer/auth/v1/passwordless/enroll",
    data: {
      email: email,
      encryptedPayload: encryptedPayload,
      otp: otp,
      passwordlessOptions: passwordlessOptions
    },
    headers: {
      "Authorization": thdCustomer.jwt
    }
  }
}

export function submitWebAuthnEnrollmentRequest (frState, webAuthnDeviceId) {
  const url = "/customer/auth/v1/webauthn/enroll";
  return {
    url: url,
    data: {
      frState: frState,
      webAuthnDeviceId: webAuthnDeviceId
    },
    headers: {
      "Authorization": thdCustomer.jwt
    }
  }
}

export function getOtpOptionsRequest(email) {
  return {
    url: "/customer/auth/v1/otp/options",
    data: {
      email
    },
    headers: {
      "Authorization": thdCustomer.jwt,
      "TMXProfileID": getTMXSessionID()
    }
  }
}

export function updatePasswordWithOTPRequest(password, email, encryptedPayload, otp, origin) {
  return {
    url: "/customer/auth/v1/updatePassword",
    data: {
      password,
      email,
      encryptedPayload,
      otp,
      updatePwdOnPage: true,
      customerID: thdCustomer.userID,
      customerType: thdCustomer.customerType,
      noPasswordSet: origin === "UnenrollmentPasswordSet" ? true : false
    },
    headers: {
      "Authorization": thdCustomer.jwt,
      "TMXProfileID": getTMXSessionID()
    }
  }
}
